<template>
  <view class="banner">
    <swiper class="swiper" :indicator-dots="false" :circular="true" >
      <swiper-item v-for="(item,index) in list" :key="index">
        <view class="swiper-item">
          <div class="card">
			  <image class="pic" lazy-load :src="item.imageUrl" mode="aspectFill" />
			  <p class="title">
				{{ item.contentTitle }}
			  </p>
			  <div class="txt">
				{{ item.txt }}
			  </div>
			</div>
        </view>
      </swiper-item>
    </swiper>
  </view>
</template>
<script>
export default {
  name: "vanThreeSlide",
  data() {
    return {
    };
  },
  props: {
      dataList: {
        type: Array,
        default () {
          return []
        }
      }
    },
	computed:{
		list(){
			let arr=this.dataList
			arr.push.apply(arr,this.dataList)
			return arr
		}
	}
};
</script>
<style lang="less" scoped>
.swiper{
	// height:220px;
	height:180px;
	/deep/swiper-item{width:140px !important;}
}
.banner {
  overflow: hidden;
  padding: 10px 0 10px 15px;
}
.card {
  overflow: hidden;
  width: 130px;
  .pic{
    width: 130px;
    height: 150px;
    border-radius: 4px;
  }
  .title {
    width: 130px;
    color: #333;
    font-size: 15px;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    line-height: 21px;
    margin-top: 3px;
    text-overflow: ellipsis;
  }
  .txt {
    color: #999;
    width: 130px;
    font-size: 12px;
    line-height: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .footer {
    display: flex;
    justify-content: space-between;
    padding: 0 10px;
    margin-top: 10px;
    .label {
      color: #ff740b;
      border-radius: 4px;
      background: none;
      border: 1px #ff740b solid;
      padding: 4px 6px;
    }
    .number {
      color: #999;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
    }
  }
}
</style>
